import { RegService } from "@common/service/base-service/reg";

interface RegCheck {
  isOk: boolean;
  errorMsg: string;
}
export default class RegCheckService {
  // 前端验证验证码格式
  static async checkCodeByReg(code): Promise<RegCheck> {
    if (!code) {
      return RegCheckService.formatResult("验证码不能为空");
    }
    if (!RegService.CODE_4.test(code)) {
      return RegCheckService.formatResult("验证码格式错误");
    }
    return RegCheckService.formatResult();
  }
  // 前端验证验证码格式-2b
  static async checkCodeByRegTob(code): Promise<RegCheck> {
    if (!code) {
      return RegCheckService.formatResult("验证码不能为空");
    }
    if (!RegService.CODE_6.test(code)) {
      return RegCheckService.formatResult("验证码格式错误");
    }
    return RegCheckService.formatResult();
  }
  static async checkPhoneNumByReg(phoneNum): Promise<RegCheck> {
    if (!phoneNum) {
      return RegCheckService.formatResult("手机号不能为空");
    }
    if (!RegService.PHONE.test(phoneNum)) {
      return RegCheckService.formatResult("手机号格式错误");
    }
    return RegCheckService.formatResult();
  }

  // 检验密码格式
  static async checkPasswordByReg(password): Promise<RegCheck> {
    const len = password.length;
    if (len === 0) {
      return RegCheckService.formatResult("密码不能为空");
    }
    if (len < 8 || len > 32) {
      return RegCheckService.formatResult("密码长度需8-32位字符");
    }
    if (!RegService.PASSWORD_ICT.test(password)) {
      return RegCheckService.formatResult(
        "要求仅为数字、大小写字母及特殊字符且至少包含三种及以上"
      );
    }
    if (
      RegService.PASSWORD_REPEAT_4.test(password) ||
      RegService.LxStr(password, 5)
    ) {
      return RegCheckService.formatResult("连续或相同的数字、字母不能超过4位");
    }
    return RegCheckService.formatResult();
  }

  // 校验邮箱格式
  static async checkEmailByReg(email: string) {
    if (!email) {
      return RegCheckService.formatResult("邮箱不能为空");
    }

    if (!RegService.EMAIL.test(email)) {
      return RegCheckService.formatResult("邮箱格式错误");
    }

    return RegCheckService.formatResult();
  }

  static async formatResult(errorMsg = ""): Promise<RegCheck> {
    if (errorMsg) {
      return Promise.reject({
        isOk: false,
        errorMsg
      });
    } else {
      return Promise.resolve({
        isOk: true,
        errorMsg: ""
      });
    }
  }
}
